import type { ReduxAction } from "actions/ReduxActionTypes";
import {
  ReduxActionErrorTypes,
  ReduxActionTypes,
} from "ee/constants/ReduxActionConstants";
import type {
  RoleAssigneesPayload,
  RoleProps,
} from "ee/pages/AdminSettings/AccessControl/types";
import type { AclReduxState } from "./types";

export const rolesReducers = {
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.FETCH_ACL_ROLES]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.FETCH_ACL_ROLES_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.FETCH_ACL_ROLES_SUCCESS]: (state: any, action: any) => ({
    ...state,
    roles: action.payload,
    isLoading: false,
    ...(state.selectedRole
      ? {
          selectedRole: {
            ...state.selectedRole,
            isNew: false,
          },
        }
      : {}),
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.FETCH_ACL_ROLE_BY_ID]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.FETCH_ACL_ROLE_BY_ID_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  [ReduxActionTypes.FETCH_ACL_ROLE_BY_ID_SUCCESS]: (
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: any,
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any,
  ) => ({
    ...state,
    selectedRole: {
      ...action.payload,
      isSaving: false,
      isNew: false,
    },
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.CREATE_ACL_ROLE]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.CREATE_ACL_ROLE_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.CREATE_ACL_ROLE_SUCCESS]: (state: any, action: any) => ({
    ...state,
    selectedRole: {
      ...action.payload,
      isSaving: false,
      isNew: true,
    },
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.CLONE_ACL_ROLE]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.CLONE_ACL_ROLE_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.CLONE_ACL_ROLE_SUCCESS]: (state: any, action: any) => ({
    ...state,
    roles: action.payload,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.UPDATE_ACL_ROLE_NAME]: (state: any) => ({
    ...state,
    isSavingName: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.UPDATE_ACL_ROLE_NAME_ERROR]: (state: any) => ({
    ...state,
    selectedRole: {
      ...state.selectedRole,
      isNew: false,
    },
    isSavingName: false,
  }),
  [ReduxActionTypes.UPDATE_ACL_ROLE_NAME_SUCCESS]: (
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: any,
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any,
  ) => ({
    ...state,
    selectedRole: {
      ...state.selectedRole,
      name: action.payload.name,
      description: action.payload.description,
      isNew: false,
    },
    isSavingName: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.UPDATE_ACL_ROLE]: (state: any) => ({
    ...state,
    selectedRole: {
      ...state.selectedRole,
      isSaving: true,
      isNew: false,
    },
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.UPDATE_ACL_ROLE_ERROR]: (state: any) => ({
    ...state,
    selectedRole: {
      ...state.selectedRole,
      isSaving: false,
      isNew: false,
    },
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.UPDATE_ACL_ROLE_SUCCESS]: (state: any, action: any) => ({
    ...state,
    selectedRole: {
      ...state.selectedRole,
      tabs: action.payload.tabs,
      userPermissions:
        action.payload.userPermissions ?? state.selectedRole.userPermissions,
      isSaving: false,
      isNew: false,
    },
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.DELETE_ACL_ROLE]: (state: any) => ({
    ...state,
    isLoading: true,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.DELETE_ACL_ROLE_ERROR]: (state: any) => ({
    ...state,
    isLoading: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.DELETE_ACL_ROLE_SUCCESS]: (state: any, action: any) => ({
    ...state,
    roles: state.roles.filter(
      (role: RoleProps) => role.id !== action.payload.id,
    ),
    isLoading: false,
  }),
  [ReduxActionTypes.FETCH_ICON_LOCATIONS_SUCCESS]: (
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: any,
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any,
  ) => ({
    ...state,
    iconLocations: action.payload,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionErrorTypes.FETCH_ICON_LOCATIONS_ERROR]: (state: any) => ({
    ...state,
    iconLocations: [],
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.RESET_ROLES_DATA]: (state: any) => ({
    ...state,
    selectedRole: null,
    roles: [],
    roleAssignees: null,
    isLoadingRoleAssignees: false,
    isLoadingMoreRoleAssignees: false,
    hasRoleAssigneesError: false,
    hasMoreRoleAssigneesError: false,
  }),
  [ReduxActionTypes.FETCH_ROLE_ASSIGNEES]: (state: AclReduxState) => ({
    ...state,
    // Keep existing assignees while refetching so revisiting the tab / searching
    // does not flash a full-page spinner over data that is already loaded.
    isLoadingRoleAssignees: true,
    isLoadingMoreRoleAssignees: false,
    hasRoleAssigneesError: false,
    hasMoreRoleAssigneesError: false,
  }),
  [ReduxActionErrorTypes.FETCH_ROLE_ASSIGNEES_ERROR]: (
    state: AclReduxState,
  ) => ({
    ...state,
    isLoadingRoleAssignees: false,
    roleAssignees: null,
    hasRoleAssigneesError: true,
  }),
  [ReduxActionTypes.FETCH_ROLE_ASSIGNEES_SUCCESS]: (
    state: AclReduxState,
    action: ReduxAction<RoleAssigneesPayload>,
  ) => ({
    ...state,
    roleAssignees: action.payload,
    isLoadingRoleAssignees: false,
    hasRoleAssigneesError: false,
  }),
  [ReduxActionTypes.FETCH_NEXT_ROLE_ASSIGNEES]: (state: AclReduxState) => ({
    ...state,
    isLoadingMoreRoleAssignees: true,
    hasMoreRoleAssigneesError: false,
  }),
  [ReduxActionErrorTypes.FETCH_NEXT_ROLE_ASSIGNEES_ERROR]: (
    state: AclReduxState,
  ) => ({
    ...state,
    isLoadingMoreRoleAssignees: false,
    hasMoreRoleAssigneesError: true,
  }),
  [ReduxActionTypes.FETCH_NEXT_ROLE_ASSIGNEES_SUCCESS]: (
    state: AclReduxState,
    action: ReduxAction<RoleAssigneesPayload | null>,
  ) => ({
    ...state,
    roleAssignees: action.payload,
    isLoadingMoreRoleAssignees: false,
    hasMoreRoleAssigneesError: false,
  }),
  [ReduxActionTypes.RESET_ROLE_ASSIGNEES]: (state: AclReduxState) => ({
    ...state,
    roleAssignees: null,
    isLoadingRoleAssignees: false,
    isLoadingMoreRoleAssignees: false,
    hasRoleAssigneesError: false,
    hasMoreRoleAssigneesError: false,
  }),
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.IS_SAVING_ROLE]: (state: any, action: any) => ({
    ...state,
    selectedRole: {
      ...state.selectedRole,
      isSaving: action.payload,
      isNew: false,
    },
  }),
};
